function calculateRepeatDuration(duration, repeat, repeatDelay) {
    return duration * (repeat + 1) + repeatDelay * repeat;
}

export { calculateRepeatDuration };
//# sourceMappingURL=calc-repeat-duration.mjs.map
